export const columns = [
    {
        dataField: 'displayName',
        text: 'Permission',
        sort: true,
        headerStyle: { borderColor: '#a81933', width: '70%' },
    },
    {
        dataField: 'isEnabled',
        text: 'Enabled',
        sort: true,
        allowCheckAll: false,
        headerStyle: { borderColor: '#a81933', width: '15%' },
        isCheckbox: true,
    }
];

export const sorting = [{
    dataField: 'displayOrder',
    order: 'asc'
}];